<template>
  <div>
    <nav id="sidebar">
      <div class="logo-wrapper">
        <img class="" :src="require('@/assets/images/yt-initials-logo.png')" alt="initials-logo" width="100%" />
      </div>
      <div class="sidebar__link-container">
        <ul>
          <li v-for="route in routes" :key="route.id" @click="scrollToAnchor(route.id)"
            class="text--grey sidebar__link flex flex-justify-center flex-align-center">
            {{ route.title }}
          </li>
        </ul>
        <div class="sidebar__link-overlay" id="sidebar__link-overlay" />
      </div>
      <div class="socials-container"></div>
    </nav>
    <contactMe v-if="isContactMe" @close="isContactMe = false" />
  </div>
</template>
<script>
import contactMe from "../home/contactMe.vue";
export default {
  components: { contactMe },
  data() {
    return {
      routes: [
        { id: "home-hero-section", title: "Home" },
        { id: "about-me-section", title: "About" },
        { id: "my-skills-section", title: "Skills" },
        { id: "my-projects-section", title: "Projects" },
        { id: "contact-me-section", title: "Contact" },
      ],
      isContactMe: false,
    };
  },
  methods: {
    scrollToAnchor(id) {
      if (id == "contact-me-section") {
        this.isContactMe = true;
      } else {
        const top = document.getElementById(id).offsetTop;
        window.scrollTo(0, top);
      }
    },
  },
  watch: {
    isContactMe: function (newVal) {
      if (newVal) {
        document.body.classList.add("stop-scrolling");
      } else {
        document.body.classList.remove("stop-scrolling");
      }
    },
  },
  created() {
    this.$store.subscribeAction({
      after: (action) => {
        if (action.type === "setPageNumber") {
          document.getElementById("sidebar__link-overlay").style.top =
            action.payload * 51 + "px";
        }
      },
    });
  },
};
</script>
<style lang="scss" scoped>
#sidebar {
  height: 100vh;
  width: 120px;
  background-color: #111111;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.logo-wrapper {
  padding-top: 50px;
}

.sidebar__link-container {
  cursor: pointer;
  border-top: 1px solid rgb(104, 104, 104);
  text-align: center;
  position: relative;

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  li {
    height: 50px;
    border-bottom: 1px solid rgb(104, 104, 104);
  }
}

.sidebar__link-overlay {
  position: absolute;
  top: 0;
  height: 51px;
  width: 100%;
  background-color: rgba(219, 219, 219, 0.055);
  transition: top 500ms linear;
}

.socials-container {
  height: 200px;
}
</style>
